
<div class="icon" [ngSwitch]="notification.type">
    <i *ngSwitchCase="'INFO'" class="fas fa-info-circle text-primary"></i>
    <i *ngSwitchCase="'WARNING'" class="fas fa-exclamation text-warning"></i>
    <i *ngSwitchCase="'ERROR'" class="fas fa-exclamation-circle text-danger"></i>
    <i *ngSwitchCase="'ALERT'" class="fas fa-exclamation-circle text-danger"></i>
</div>
<div class="details">
    <div class="message">
        <div [innerHtml]="notification.message"></div>
    </div>
    <div class="date">
        <span>{{notification.date | date:'mediumTime'}}</span>
    </div>
</div>